import { render, staticRenderFns } from "./menu-csv-import.vue?vue&type=template&id=d1b64c5c&"
import script from "./menu-csv-import.vue?vue&type=script&lang=js&"
export * from "./menu-csv-import.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports